import React, {Component} from 'react'
import {base} from '../../base';
import posed, { PoseGroup } from 'react-pose';

import '../../styles/css/CreatorAwards.css'
import ProgressButton from '../utils/ProgressButton'

const Trans = posed.div({
  enter: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: ({ delta }) => - delta * 100 + 'vw' }
})

const Box = posed.div({
  visible: { opacity: 1 },
  hidden: { opacity: 0 }
})

class TriviaBigScreenHorizontal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            frozenVotingState: [],
            answers: [],
            questions: [],
            question: 0,
            currentGame: {},
            isVisible: false,
            rotate: false,
            questionAnswered: false
            // triviaGameOn: false,
        };
    }

componentDidMount() {
    this.currentTriviaGameRef = base.bindToState('currentTriviaGame', {
      context: this,
      state: 'currentGame',
    })
    this.questionAnsweredRef = base.bindToState('currentTriviaGame/answered', {
      context: this,
      state: 'questionAnswered',
    })

    this.questionTextRef = base.bindToState(`currentTriviaGame/questions`, {
      context: this,
      state: 'questions'
    });
}

handleImageLoaded() {
  setTimeout(() => this.setState({
    isVisible: true
  }), 1);
}

handleImageErrored() {
  console.log("Image failed to load")
  this.setState({ loading: false });
}

componentWillUnmount() {
    base.removeBinding(this.questionTextRef);
    base.removeBinding(this.questionAnsweredRef);
    base.removeBinding(this.currentTriviaGameRef);
}

renderAnswerScreen(tenantVariables, currentQuestion){
  var cleanedAnswersArray = currentQuestion.answers || [];
  return (
    <Trans key={233}>
      <div className="grid-container-big-screen-single">
          {
              cleanedAnswersArray.map(function(item,i){
                if(item.correct){
                return <div key={i} className="item-scoreboard">
                        <ProgressButton variables={tenantVariables} title={item.answerText} correct={true} from={false}/>
                    </div>
                  }
              }, this)
            }
        </div>
    </Trans>
  )
}

renderAnswersScreen(tenantVariables, currentQuestion){
  var cleanedAnswersArray = currentQuestion.answers || [];
  var answerSize = '44px'
  if(tenantVariables.answerssizeHorizontal && tenantVariables.answerssizeHorizontal.trim().length > 0){
    answerSize = tenantVariables.answerssizeHorizontal + "px"
  }
  return (
    <Trans key={232}>
      { cleanedAnswersArray.length > 3 ? (
        <div className="grid-container-big-screen-side">
        {
            cleanedAnswersArray.map(function(item,i){
              return <div key={i} className="grid-item-big-screen" style={{backgroundColor: tenantVariables.progressBarBackgroundColor}}>
                    <span style={{color: tenantVariables.progressBarTextColor, fontSize: answerSize}}>{item.answerText}</span>
              </div>
            }, this)
          }
        </div>
      ) : (
        <div className="grid-container-big-screen-top">
        {
            cleanedAnswersArray.map(function(item,i){
              return <div key={i} className="grid-item-big-screen-top" style={{backgroundColor: tenantVariables.progressBarBackgroundColor}}>
                    <span style={{color: tenantVariables.progressBarTextColor, fontSize: answerSize}}>{item.answerText}</span>
              </div>
            }, this)
          }
        </div>
      )}
    </Trans>
  )
}

renderQuestionScreen(tenantVariables, currentQuestion){
  var questionText = '80px'
  if(tenantVariables.questionsizeHorizontal && tenantVariables.questionsizeHorizontal.trim().length > 0){
    questionText = tenantVariables.questionsizeHorizontal + "px"
  }
  return (
    <Trans key={2} className="centerTextOnScreen">
      <div className="centerTable">
        <p style={{display: "table-cell", verticalAlign: "middle", wordWrap: "break-word", fontWeight:900, fontSize:questionText, color: tenantVariables.progressBarQuestionTextColor}}>{currentQuestion.questionText}</p>
      </div>
    </Trans>
  )
}

render() {
    var tenantVariables = this.props.variables || {};
    var currentGame = this.state.currentGame;
    var questions = currentGame.questions || [];

    var cleanedAnswersArray = [];
    var highestRanked = {};

    // var totalTriviaAnswers = 0;
    var currentQuestion = {}
    if(questions.length > 0){
      currentQuestion = questions[currentGame.questionToShow] || questions[0]
    }

    var renderCenterScreen = this.renderQuestionScreen(tenantVariables, currentQuestion)
    if(currentGame.screenToShow === 2){
      renderCenterScreen = this.renderAnswerScreen(tenantVariables, currentQuestion)
    } else if (currentGame.screenToShow === 1) {
      renderCenterScreen = this.renderAnswersScreen(tenantVariables, currentQuestion)
    }
    return (
        <center className="grid-wrapper" style={{backgroundImage: "url(" + tenantVariables.scoreboardBackgroundImage + ")"}}>
          <Box pose={this.state.isVisible ? 'visible' : 'hidden'} style={{width:"100%", textAlign: "center",position: "absolute",top: 0}}>
            <img src={tenantVariables.topOfScoreboardImage} onLoad={this.handleImageLoaded.bind(this)} onError={this.handleImageErrored.bind(this)} alt=""/>
          </Box>
          <PoseGroup animateOnMount={true} delta={1}>
            {renderCenterScreen}
          </PoseGroup>
          <Box pose={this.state.isVisible ? 'visible' : 'hidden'} style={{width:"100%", textAlign: "center",position: "absolute",bottom: 0}}>
            <img src={tenantVariables.belowScoreboardSponsorshipImage} onLoad={this.handleImageLoaded.bind(this)} onError={this.handleImageErrored.bind(this)} alt=""/>
          </Box>
        </center>
      )
    }
}

export default TriviaBigScreenHorizontal;



// WEBPACK FOOTER //
// ./src/components/main_screens/TriviaBigScreenHorizontal.js